import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCapitalLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchCapitalLedger = createAsyncThunk(
  "capitalLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const response = await getCapitalLedgerApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error fetching ledger");
    }
  }
);

export const fetchCapitalAccountsBySearch = createAsyncThunk(
  "capitalLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["capital"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);